<template>
  <div class="ticket-holder-modal">
    <div class="ticket-holder-form">
      <div class="ticket-holder-form_info">
        <div class="ticket-holder-form-info-div">
          <div class="card">
            <skeleton-loader class="skeleton-title" />
            <skeleton-loader class="skeleton-line" />
            <skeleton-loader class="skeleton-line" />
            <skeleton-loader class="skeleton-line" />
          </div>
          <div class="card">
            <skeleton-loader class="skeleton-title" />
            <skeleton-loader class="skeleton-line" />
            <skeleton-loader class="skeleton-line" />
            <skeleton-loader class="skeleton-line" />
          </div>
        </div>
        <div class="photo-card card">
          <skeleton-loader class="skeleton-title" />
          <skeleton-loader class="photo-box"/>
          <skeleton-loader class="skeleton-hint" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { SkeletonLoader } from '@bookingkit/coppi';
</script>

<style scoped>
.ticket-holder-modal {
  overflow: scroll;
  height: 85vh;
  margin-top: var(--s10);
}

.ticket-holder-form {
  display: flex;
  flex-direction: column;
  margin: var(--s3) var(--s7) var(--s8) var(--s7);
  gap: var(--s5);
}

.ticket-holder-form_info {
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: var(--s7);
}

.ticket-holder-form-info-div {
  display: flex;
  flex-direction: column;
  gap: 100px;
  min-width: 370px;
}

.photo-card.card {
    max-width: 330px;
    margin-left: 70px;
}

.card {
  overflow: hidden;
  border-radius: var(--s3);
  display: flex;
  flex-direction: column;
  gap: var(--s4);
  max-width: 360px;
}

.skeleton-title {
  width: 40%;
  height: 22px;
}

.skeleton-line {
  width: 100%;
  height: 44px;
  margin-top: var(--s4);
}

.photo-box {
  width: 100%;
  height: 260px;
  margin-top: var(--s5);
  border-radius: var(--s3);
  min-width: 300px;
  min-height: 300px;
}

.skeleton-hint {
  width: 60%;
  height: 18px;
  margin-top: var(--s4);
}

.btn-skeleton {
  width: 160px;
  height: 40px;
}

@media (max-width: 768px) {
  .ticket-holder-modal {
    max-height: 100vh;
  }

  .ticket-holder-form_info {
    display: flex;
    flex-direction: column;
  }

  .ticket-holder-form-info-div {
    min-width: 100%;
  }

  .ticket-holder-form {
    margin: var(--s3) var(--s7) var(--s20) var(--s7);
  }

    .photo-card.card {
        width: auto;
        margin-left: 0;
    }
}
</style>
